<script>
import Layout from "../../layouts/main";
import BecomePartnerForm from './become-partner-form';
import appConfig from "@/app.config";


export default {
  page: {
    title: "Nos Partenaires",
    meta: [{ name: "description", content: appConfig.description }]
  },
    components: { Layout, BecomePartnerForm},
    name: 'PartnerSection',

    data() {
        return {

      
    };
  },

  watch: {
    
  },
  mounted() {
    this.observeImages();
  },
  methods: {

    


    observeImages() {
      const images = document.querySelectorAll('.image-slide-in');

      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1,
      });

      images.forEach(image => {
        observer.observe(image);
      });
    }
  }
};
</script>
<template>
    <Layout>


    <div class="bg-white text-center pt-md-5 pb-md-5 pt-0 pb-0">
      <div>
        <div class="pt-0">
          <h1 class="pt-5 text-dark text-wrap font-weight-bold" style="font-size:2.5rem;">
            {{$t('ourPartner.ourPartners')}}
          </h1>
        </div>

        <hr class="separator-line mt-3">

        <div class="mt-5">
          <h6 class="header-60-width mx-auto text-dark font-size-16 text-wrap" style="letter-spacing: 0.08em; line-height: 1.8;">
            {{$t('ourPartner.partnersDescription')}} 
          </h6>
        </div>
      </div>
    </div>





        <div class="bg-white">

            <!-- <div class="header text-center pb-5">
                <div class="">
                    <div class="pt-4">
                        <h1 class="pt-5 text-white text-wrap">
                            {{$t('ourPartner.remerciements')}}
                        </h1>
                    </div>

                    <hr class="separator-line mt-5">

                    <div class="mt-4">
                        <h6 class="header-60-width mx-auto text-light text-wrap" style="letter-spacing: 0.08em; line-height: 1.8;">
                            {{$t('ourPartner.subtitle1')}}
                            <strong>{{$t('ourPartner.companyName')}}</strong>
                        </h6>
                    </div>
                </div>
            </div> 


            <div class="text-center mt-5 font-weight-bold ">
                <div class="font-size-24 text-primary mb-4">
                    {{$t('ourPartner.title')}}
                </div>
                <div class=" font-size-20 mb-2 mx-auto text-dark" style="max-width: 80%;">
                    {{$t('ourPartner.becomePartner')}}
                </div>
                <div class=" font-size-20 mx-auto text-dark" style="max-width: 80%;" >
                    {{$t('ourPartner.concept')}}
                </div>
            </div>

            <div class="mt-md-5 mt-4 pt-md-5 pt-4 header-60-width">
                <div class="row justify-content-center align-items-center mt-5">
                    <div class="col-lg-5 d-flex justify-content-center flex-column align-items-center">
                        <div class="mr-2">
                            <div class="mb-4" ref="image1">
                                <img :src="require(`@/assets/images/bagsBa.png`)" alt="bagsBa" class="img-fluid rounded shadow-lg image-slide-in" style="width: 100%; height: auto;">
                            </div>
                            <div ref="image2">
                                <img :src="require(`@/assets/images/sac-pharmacie.jpg`)" alt="sac-pharmacie" class="img-fluid rounded shadow-lg image-slide-in" style="width: 100%; height: auto;">
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-7">
                        <div class="ml-2 p-4">
                            <h3 class="font-weight-bold mb-3 text-dark" style="text-transform: uppercase;">
                                {{$t('ourPartner.pioneerTitle')}}
                            </h3>
                            <p class="text-muted mb-4 font-size-16" style="line-height: 1.6;">
                                {{$t('ourPartner.pioneerDescription')}}
                            </p>
                            <p class="text-secondary font-size-16" style="line-height: 1.8;">
                                {{$t('ourPartner.pioneerExtendedDescription')}}
                            </p>
                        </div>
                    </div>
                </div>
            </div> -->



            <div class="text-center ">

                <!-- <h2 class="text-center text-primary font-weight-bold mb-4">
                    {{$t('ourPartner.ourPartners')}}
                </h2>

                <div class="header-60-width font-size-18 text-dark">
                    {{$t('ourPartner.partnersDescription')}}
                </div> -->

                <div class="d-flex justify-content-center">
                    <iframe 
                        class="col-sm-12 col-md-8 mt-md-5 mt-2 m-md-0 m-4 responsive-iframe"
                        src="https://www.google.com/maps/d/embed?mid=1FI910OiNn__22aB2T6eRJFxnM8p0oA7f&amp;hl=en" 
                        style="border-radius: 8px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); width: 100%; height: 700px;"
                        loading="lazy">
                    </iframe>
                </div>

            </div>




           


            <div class="header-60-width">

              <div class="text-center pt-md-5 pb-md-5 pt-0 pb-0">
      <div>
        <div class="pt-0">
          <h1 class="pt-5 text-dark text-wrap font-weight-bold" style="font-size:2.5rem;">
            {{$t('ourPartner.joinUs')}}
          </h1>
        </div>

        <hr class="separator-line mt-3 mb-3">

        <div class="mt-5">
          <h6 class="mx-auto text-dark font-size-16 text-wrap" style="letter-spacing: 0.08em; line-height: 1.8;">
            {{$t('ourPartner.partnersDescription')}} 
          </h6>
        </div>
      </div>
    </div>

              <BecomePartnerForm class="pt-5 pt-md-0 pb-5" />

            </div>



        </div>

      
    </Layout>
  </template>


  
  <style scoped>


  .header {
    background:  linear-gradient(19deg,rgba(55, 152, 91, 1) 0%,rgba(19, 116, 55, 1) , rgba(23, 83, 45, 1) 100%)!important;
    text-align: center;
  }
  
  .header-60-width,
.sub-title-60-width {
    max-width: 90%;
    margin: auto;
}

@media (min-width: 768px) {
    .header-60-width,
    .sub-title-60-width {
        max-width: 60%;
    }
}
  .separator-line {
    width: 15%;
    height: 4px;
    background-color: #137437 ;
    border: none;
    margin: auto; 
  }
  
  .sub-title-60-width {
    margin: 30px auto 0;
    color: #f7d584;
  }

  .responsive-iframe {
    height: 450px;
}

@media (min-width: 768px) {
    .responsive-iframe {
        height: 650px;
    }
}
  </style>
  


  <style scoped>
.image-slide-in {
  transform: translateX(-100%); 
  opacity: 0;
  transition: transform 1s ease-out, opacity 1s ease-out; 
}


.image-slide-in.animate {
  transform: translateX(0);
  opacity: 1;
}


  </style>